function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $3f089cc48d72c428$exports = {};

$parcel$export($3f089cc48d72c428$exports, "SUPER_USER_PERMISSION", () => $3f089cc48d72c428$export$7f0c06be0bd6e481);
$parcel$export($3f089cc48d72c428$exports, "decodeSubscriptionPermission", () => $3f089cc48d72c428$export$79932a47efbad117);
$parcel$export($3f089cc48d72c428$exports, "decodeHallPermission", () => $3f089cc48d72c428$export$18fbd3bd93bcc69);
$parcel$export($3f089cc48d72c428$exports, "encodeSubscriptionPermission", () => $3f089cc48d72c428$export$71114f19766c6083);
var $215290a4ea14e028$exports = {};

$parcel$export($215290a4ea14e028$exports, "HallPermissionBits", () => $215290a4ea14e028$export$44e46b63f36dc8db);
let $215290a4ea14e028$export$44e46b63f36dc8db;
(function(HallPermissionBits) {
    HallPermissionBits[HallPermissionBits["isAdmin"] = 1] = "isAdmin";
    HallPermissionBits[HallPermissionBits["isException"] = 2] = "isException";
    HallPermissionBits[HallPermissionBits["isOwner"] = 4] = "isOwner";
    HallPermissionBits[HallPermissionBits["addMembers"] = 256] = "addMembers";
    HallPermissionBits[HallPermissionBits["addNewAdmins"] = 512] = "addNewAdmins";
    HallPermissionBits[HallPermissionBits["banUsers"] = 1024] = "banUsers";
    HallPermissionBits[HallPermissionBits["changeHallInfo"] = 2048] = "changeHallInfo";
    HallPermissionBits[HallPermissionBits["deleteMessages"] = 4096] = "deleteMessages";
    HallPermissionBits[HallPermissionBits["editMessage"] = 8192] = "editMessage";
    HallPermissionBits[HallPermissionBits["inviteViaLink"] = 16384] = "inviteViaLink";
    HallPermissionBits[HallPermissionBits["pinMessage"] = 32768] = "pinMessage";
    HallPermissionBits[HallPermissionBits["sendMedia"] = 65536] = "sendMedia";
    HallPermissionBits[HallPermissionBits["sendMessage"] = 131072] = "sendMessage";
    HallPermissionBits[HallPermissionBits["sendWapp"] = 262144] = "sendWapp";
    HallPermissionBits[HallPermissionBits["SENDS"] = 458752] = "SENDS";
    HallPermissionBits[HallPermissionBits["DEFAULT_CHANNEL"] = 0] = "DEFAULT_CHANNEL";
    HallPermissionBits[HallPermissionBits["DEFAULT_CHANNEL_OWNER"] = 524037] = "DEFAULT_CHANNEL_OWNER";
    HallPermissionBits[HallPermissionBits["DEFAULT_GROUP"] = 491520] = "DEFAULT_GROUP";
    HallPermissionBits[HallPermissionBits["DEFAULT_GROUP_OWNER"] = 515845] = "DEFAULT_GROUP_OWNER";
    HallPermissionBits[HallPermissionBits["FIXED_CHANNEL_ADMIN"] = 50177] = "FIXED_CHANNEL_ADMIN";
    HallPermissionBits[HallPermissionBits["FIXED_GROUP_ADMIN"] = 459009] = "FIXED_GROUP_ADMIN";
    HallPermissionBits[HallPermissionBits["FIXED_GROUP_MEMBER"] = 2] = "FIXED_GROUP_MEMBER";
    HallPermissionBits[HallPermissionBits["CHANGEABLE_CHANNEL_ADMIN"] = 473856] = "CHANGEABLE_CHANNEL_ADMIN";
    HallPermissionBits[HallPermissionBits["CHANGEABLE_GROUP_ADMIN"] = 56832] = "CHANGEABLE_GROUP_ADMIN";
    HallPermissionBits[HallPermissionBits["CHANGEABLE_GROUP_MEMBER"] = 493824] = "CHANGEABLE_GROUP_MEMBER";
    HallPermissionBits[HallPermissionBits[// assert(CHANGEABLE_GROUP_MEMBER & ~(FIXED_GROUP_ADMIN | CHANGEABLE_GROUP_ADMIN) === 0)
    // foreach: assert(changeable & fixed === 0)
    "SUPER_USER"] = -1] = "SUPER_USER";
})($215290a4ea14e028$export$44e46b63f36dc8db || ($215290a4ea14e028$export$44e46b63f36dc8db = {}));


function $3f089cc48d72c428$var$decodePermission(perms) {
    return {
        addMembers: Boolean(perms & (0, $215290a4ea14e028$export$44e46b63f36dc8db).addMembers),
        addNewAdmins: Boolean(perms & (0, $215290a4ea14e028$export$44e46b63f36dc8db).addNewAdmins),
        banUsers: Boolean(perms & (0, $215290a4ea14e028$export$44e46b63f36dc8db).banUsers),
        changeHallInfo: Boolean(perms & (0, $215290a4ea14e028$export$44e46b63f36dc8db).changeHallInfo),
        deleteMessages: Boolean(perms & (0, $215290a4ea14e028$export$44e46b63f36dc8db).deleteMessages),
        editMessage: Boolean(perms & (0, $215290a4ea14e028$export$44e46b63f36dc8db).editMessage),
        inviteViaLink: Boolean(perms & (0, $215290a4ea14e028$export$44e46b63f36dc8db).inviteViaLink),
        pinMessage: Boolean(perms & (0, $215290a4ea14e028$export$44e46b63f36dc8db).pinMessage),
        sendMedia: Boolean(perms & (0, $215290a4ea14e028$export$44e46b63f36dc8db).sendMedia),
        sendMessage: Boolean(perms & (0, $215290a4ea14e028$export$44e46b63f36dc8db).sendMessage),
        sendWapp: Boolean(perms & (0, $215290a4ea14e028$export$44e46b63f36dc8db).sendWapp),
        isAdmin: Boolean(perms & (0, $215290a4ea14e028$export$44e46b63f36dc8db).isAdmin),
        isOwner: Boolean(perms & (0, $215290a4ea14e028$export$44e46b63f36dc8db).isOwner),
        raw: perms
    };
}
const $3f089cc48d72c428$export$7f0c06be0bd6e481 = {
    ...$3f089cc48d72c428$var$decodePermission((0, $215290a4ea14e028$export$44e46b63f36dc8db).SUPER_USER),
    isSuperUser: true
};
function $3f089cc48d72c428$export$79932a47efbad117(hallPerm, subscriptionPerm) {
    const perms = subscriptionPerm & (0, $215290a4ea14e028$export$44e46b63f36dc8db).isException ? subscriptionPerm & hallPerm : subscriptionPerm & (0, $215290a4ea14e028$export$44e46b63f36dc8db).isAdmin ? subscriptionPerm | hallPerm : hallPerm;
    return $3f089cc48d72c428$var$decodePermission(perms);
}
function $3f089cc48d72c428$export$18fbd3bd93bcc69(hallPerm) {
    const { isOwner: isOwner , isAdmin: isAdmin , raw: raw , ...permissions } = $3f089cc48d72c428$var$decodePermission(hallPerm);
    return permissions;
}
function $3f089cc48d72c428$export$71114f19766c6083(permissionObj) {
    const permissions = !permissionObj.sendMessage ? {
        ...permissionObj,
        sendMedia: false,
        sendWapp: false
    } : permissionObj;
    return [
        "addMembers",
        "addNewAdmins",
        "banUsers",
        "changeHallInfo",
        "deleteMessages",
        "editMessage",
        "inviteViaLink",
        "pinMessage",
        "sendMedia",
        "sendMessage",
        "sendWapp", 
    ].reduce((val, field)=>// @ts-ignore
        permissions[field] ? val | (0, $215290a4ea14e028$export$44e46b63f36dc8db)[field] : val, 0);
}



var $c8b7de0b5a05327a$exports = {};

$parcel$export($c8b7de0b5a05327a$exports, "LIMITS", () => $c8b7de0b5a05327a$export$2e91cd085cd33e2f);
const $c8b7de0b5a05327a$export$2e91cd085cd33e2f = {
    pinnedRoomsCount: 10,
    forwardDestinationCount: 10,
    hallAdminsCount: 10,
    addMembersCount: 40,
    verificationCode: {
        length: 5,
        resendInSeconds: 120,
        maxResends: 3,
        maxTries: 10
    },
    inviteLinkSize: 16,
    userConstraints: {
        firstname: {
            minLength: 1,
            maxLength: 64
        },
        lastname: {
            minLength: 0,
            maxLength: 64
        },
        bio: {
            minLength: 0,
            maxLength: 255
        },
        username: {
            minLength: 0,
            maxLength: 32
        },
        phone: {
            minLength: 11,
            maxLength: 11
        }
    },
    draftThrottleTime: 5000
};


var $d6c539ccc364ea28$exports = {};

$parcel$export($d6c539ccc364ea28$exports, "REGEX", () => $d6c539ccc364ea28$export$b38aa3fcbc4fc60a);
$parcel$export($d6c539ccc364ea28$exports, "REGEX_COMPILED", () => $d6c539ccc364ea28$export$387204e975fd5b2e);
const $d6c539ccc364ea28$export$b38aa3fcbc4fc60a = {
    username: "[a-zA-Z][a-zA-Z0-9_]{4,31}"
};
const $d6c539ccc364ea28$export$387204e975fd5b2e = {
    username: new RegExp(`^${$d6c539ccc364ea28$export$b38aa3fcbc4fc60a.username}$`)
};


$parcel$exportWildcard(module.exports, $3f089cc48d72c428$exports);
$parcel$exportWildcard(module.exports, $215290a4ea14e028$exports);
$parcel$exportWildcard(module.exports, $c8b7de0b5a05327a$exports);
$parcel$exportWildcard(module.exports, $d6c539ccc364ea28$exports);


//# sourceMappingURL=main.js.map
